import { render, staticRenderFns } from "./TeamMemberDetail.vue?vue&type=template&id=89d576f2&scoped=true&"
import script from "./TeamMemberDetail.vue?vue&type=script&lang=js&"
export * from "./TeamMemberDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberDetail.vue?vue&type=style&index=0&id=89d576f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d576f2",
  null
  
)

export default component.exports